import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Img from 'gatsby-image'

import cx from 'classnames'

import isNull from 'lodash/isNull'
import isEmpty from 'lodash/isEmpty'

import extractContent, {CONTENT_TYPE_HTML, CONTENT_TYPE_OPTIMISE_IMAGE} from '../../helpers/extractContent'

import './styles.scss'

class Card extends Component {

  static contextTypes = {
    staticData: PropTypes.array,
  }

  render () {
    const {
      staticData
    } = this.context

    const {
      contentID,

      text,
      image,

      size,
      hoverable,
      rounded,

      className,
    } = this.props

    const fullClassname = cx("Atrakeur-CardImage", {
      "Atrakeur-CardImage--hoverable": hoverable,
      "Atrakeur-CardImage--rounded": rounded,
      [`Atrakeur-CardImage--${size}`]: size,
    }, className)

    const contentText = text === undefined && contentID ? extractContent(contentID, CONTENT_TYPE_HTML, staticData): text
    const contentImage = image === undefined && contentID ? extractContent(contentID, CONTENT_TYPE_OPTIMISE_IMAGE, staticData): image

    return (
      <div className={fullClassname}>
        { !isEmpty(contentImage) && <Img sizes={ contentImage } /> }
        { !isEmpty(contentText) && <div className="Atrakeur-CardImage-Content" dangerouslySetInnerHTML={{__html: contentText}} /> }
      </div>
    )
  }
}
export default Card



// WEBPACK FOOTER //
// ./src/components/CardImage/index.js